import request from '@/utils/httpRequest'

export default class ItsSalesOuterService {
  findSalesSummaryByRegIdAndType(regId, type) {
    return request({
      url: '/its/sales/itsSalesOuter/findSalesSummaryByRegIdAndType',
      method: 'get',
      params: { regId: regId, type: type }
    })
  }
}
